import { useMutation } from "@apollo/client";
import { Button } from "../../../../../../../components/ui";
import { DELETE_FABRICATION } from "../../../../../../../graphql/mutation/Fabrication";

const DeleteCost = props => {
  const { id, closeModal } = props;
  const [deleteFabrication, { loading, error, reset }] = useMutation(
    DELETE_FABRICATION,
    { refetchQueries: ["FetchFabricationsV2"] },
  );

  const handleDelete = async () => {
    const response = await deleteFabrication({ variables: { input: { id } } });

    if (response?.data?.deleteFabrication?.success) {
      reset();
      closeModal();
    }
  };

  if (error) {
    return (
      <>
        <div className="mt-3 inline-flex items-center justify-start rounded-md border border-transparent px-4 py-2 font-bold font-medium text-red-800 sm:text-sm">
          {error?.message ||
            error?.graphQLErrors?.map?.(({ message }) => `${message} `) ||
            "An error occurred"}
        </div>
        <div className="mt-4 flex justify-end">
          <Button
            className="mr-3"
            label="Close"
            onClick={() => {
              reset();
              closeModal();
            }}
          />
        </div>
      </>
    );
  }

  return (
    <div className="mt-4 flex justify-end">
      <Button
        className="mr-3"
        label="Cancel"
        onClick={() => {
          closeModal();
        }}
      />
      <Button
        label={loading ? "Deleting" : "Delete"}
        disabled={loading}
        onClick={handleDelete}
      />
    </div>
  );
};

export default DeleteCost;
